import React, { Component } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

class CtaButtonSm extends Component {

  componentDidMount() {
    if (this.props.isNav) {
      window.addEventListener("scroll", this.changeBackground);
    }
  }

  static changeBackground() {
    const button = document.getElementById('ctaButton');
    const buttonText = button.childNodes[0];
    if (window.scrollY > 100) {
      button.style.background = '#43AB60';
      buttonText.style.color = 'white';
    }
    if (window.scrollY === 0) {
      button.style.background = 'white';
      buttonText.style.color = '#43AB60';
    }
  }

  render() {
    const { children, bgColor, textColor, to } = this.props
    return (
      <CtaButtonSmContainer
        background={bgColor}
        id='ctaButton'
        style={{background: bgColor}}>
        <Link
          to={to}
          style={{color: textColor}}>
          {children}
        </Link>
      </CtaButtonSmContainer>
    )
  }
}

export default CtaButtonSm

const CtaButtonSmContainer = styled.span`
  background: white; 
  border-radius: 4px;
  border: 1px solid #43AB60;
  padding: 10px 20px;
  margin: auto;
  transition: all 200ms ease;
  
  &:hover {
    cursor: pointer;
    background: white !important;
    border: 1px solid ${props => props.background ? props.background : "#43AB60"};
    
    & a {
    color: ${props => props.background ? props.background : "#43AB60"} !important;
    } 
  }
  
  a {
    color: #43AB60;
    font-size: 1.6rem;
    text-decoration: none;
      width: 100%;
  height: 100%;
   
  }
`


// WEBPACK FOOTER //
// ./src/components/UI/CtaButtonSm.jsx